<template>
  <span :class="css">{{ label }}</span>
</template>

<script>
export default {
  name: 'BlockFlag',
  props: {
    boo: {
      type: Boolean,
      default: false,
      required: true
    },
    falseText: {
      type: String,
      default: 'BLOCKED'
    },
    trueText: {
      type: String,
      default: 'ALLOW'
    }
  },
  computed: {
    css () {
      return this.boo ? 'is-active' : 'is-inactive'
    },
    label () {
      return this.boo ? this.trueText : this.falseText
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../styles/bulma-variables';
  .is-inactive {
    color: $grey-light;
    white-space: nowrap;
  }
  .is-active {
    color: $success;
    white-space: nowrap;
    font-weight: 600;
  }
</style>
